import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Reusable Back Button Component
 *
 * Features:
 * - Consistent design across all screens
 * - Gray rounded button with icon
 * - Optional custom navigation path
 * - Keyboard accessible
 * - Hover and focus states
 *
 * @param {string} to - Optional custom path to navigate to (default: -1 for previous page)
 * @param {string} className - Optional additional CSS classes
 */
const BackButton = ({ to = -1, onClick, className = "" }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to === -1) {
      navigate(-1);
    } else {
      navigate(to);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`p-2 bg-gray-100 rounded-full hover:bg-gray-200 transition ${className}`}
      aria-label="Navigate back"
    >
      <svg
        className="w-5 h-5 text-gray-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
  );
};

export default BackButton;
